import { useQuery } from "@tanstack/react-query";
import axios from "../../axios";
import { getStoredSessionUser } from "../../utils/adminSession";

export const useUser = (options = {}) => {
  const hasToken =
    typeof window !== "undefined" && Boolean(window.localStorage.getItem("token"));

  return useQuery({
    queryKey: ["user"],
    queryFn: async () => {
      try {
        const { data } = await axios.get("me");
        return data?.result || data?.data || data || null;
      } catch (error) {
        return getStoredSessionUser();
      }
    },
    enabled: hasToken,
    retry: false,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};
